import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faBan, faSave, faTrashAlt, faEnvelope, faCommentDots, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { getShortDate, getInputDate, addMinutesToDateTime } from '../../Helper';
import YesNoModal from '../YesNoModal';

function AccountCommentCard(props) {
    const [editMode, setEditMode] = useState(false);
    const [accountComment, setAccountComment] = useState(props.accountComment);
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);

    const updateComment = (e) => {
        console.log('Updating account comment...');
        let value = e.target.value;
        switch (e.target.type) {
            case "number":
                value = e.target.valueAsNumber;
                break;
            case "date":
                value = new Date(e.target.value + 'T00:00');
                break;
        }
        setAccountComment({ ...accountComment, [e.target.name]: value });
    };

    const cancel = () => {
        setAccountComment(props.accountComment);
        setEditMode(false);
    };

    const save = () => {
        console.log('Saving account comment...');
        props.save(accountComment);
        setEditMode(false);
    };

    const deleteComment = () => {
        console.log("Deleting comment: " + JSON.stringify(props.accountComment));
        props.delete(props.accountComment.accountCommentID);
    };

    const editComment = () => {
        setEditMode(true);
    }

    const accountCommentJSX = (
        <div className="role-account-comment card item-details">
            <div className="properties">
                <div className="svg-label comments">
                    <i className="fas fa-comment-dots"></i>
                    <span>{props.accountComment.comment}</span>
                </div>
                <div className="svg-label">
                    <i className="fas fa-calendar-alt"></i>
                    <span>{getShortDate(props.accountComment.commentDate)}</span>
                </div>
            </div>
            {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                <div className="actions-horizontal">
                    <div onClick={editComment} className="action-icon action-edit">
                        <FontAwesomeIcon icon={faEdit} />
                    </div>
                    <div onClick={toggleDeletionConfirmationModal} className="action-icon action-delete">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                </div>
            ) : null}
            <YesNoModal title="Confirm Deletion" yesClick={deleteComment} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want delete this Comment?</YesNoModal>
        </div>
    );

    const editAccountCommentJSX = (
        <div className="accountComment card  item-details">
            <div className="properties">
                <InputGroup className="comments">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <FontAwesomeIcon icon={faCommentDots} />
                        </InputGroupText>
                    </InputGroupAddon>
                    <textarea placeholder="Comment" name="comment" value={accountComment.comment || ''} onChange={updateComment} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input type="date" placeholder="Comment Date" name="commentDate" value={getInputDate(accountComment.commentDate) || ''} onChange={updateComment} />
                </InputGroup>
            </div>
            <div className="actions-horizontal">
                <div onClick={cancel} className="action-icon action-delete">
                    <FontAwesomeIcon icon={faBan} />
                </div>
                <div onClick={save} className="action-icon action-add">
                    <FontAwesomeIcon icon={faSave} />
                </div>
            </div>
        </div>
    );

    return editMode ? editAccountCommentJSX : accountCommentJSX;
}

export default AccountCommentCard;